module.exports = __webpack_public_path__ + "img/d_10.31e4cafd.png";